import { Component, Input, OnInit } from '@angular/core';
import { Utils } from '../../utils/khuyana.utils';

@Component({
  selector: 'ms-string-split',
  templateUrl: './string-split.component.html',
})
export class StringSplitComponent implements OnInit {
  @Input() toSplit = '';
  @Input() splitter = '|';
  @Input() isDate = false;
  @Input() isEmail = false;
  @Input() isPhone = false;
  splitted: string[] = [];

  ngOnInit(): void {
    if (!this.toSplit) {
      this.splitted = [];
    } else if (!this.isDate) {
      this.splitted = this.toSplit.split(this.splitter);
    } else {
      this.splitted = Utils.splitAge(this.toSplit, this.splitter);
    }
  }
}
